import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import * as styles from './style/index.scss'
import { FormattedMessage } from 'react-intl'
import EarthIcon from '@assets/img/earth.png'
import EarthWhiteIcon from '@assets/img/global/earth-white.png'
import ArrowUp from '@assets/img/global/up-gray.png'
import ArrowDown from '@assets/img/global/down-gray.png'
import ArrowWhiteUp from '@assets/img/global/up-white.png'
import ArrowWhiteDown from '@assets/img/global/down-white.png'
import { getLang } from '@src/utils'

interface SwitchLangProps {
    className?: string
    white?: boolean
}

class SwitchLang extends ComponentExt<SwitchLangProps, any> {
    private langList = [
        { messageId: 'English', value: 'en' },
        { messageId: 'Deutsch', value: 'de' },
        { messageId: 'Español', value: 'es' },
        { messageId: 'Français', value: 'fr' },
        { messageId: 'Italiano', value: 'it' },
        { messageId: 'português', value: 'pt' },
    ]

    constructor(props) {
        super(props)
        this.state = {
            flag: false
        }
    }

    hideOrShowLang = () => {
        this.setState({
            flag: !this.state.flag
        })
    }
    switchLang = (e, value) => {
        e.stopPropagation()
        const lang = sessionStorage.getItem('language') || navigator.language
        if (!lang.includes(value)) {
            sessionStorage.setItem('language', value)
            window.location.reload()
        }
    }

    render() {
        const langItem = this.langList.find(item => getLang() === item.value)
        const currentLangMessageId = !!langItem ? langItem.messageId : this.langList[0].messageId
        const arrowUp = this.props.white ? ArrowWhiteUp : ArrowUp
        const arrowDown = this.props.white ? ArrowWhiteDown : ArrowDown
        return (
            <div className={`${styles.langWrap} ${this.props.className}`} onClick={this.hideOrShowLang}>
                <img src={this.props.white ? EarthWhiteIcon : EarthIcon} className={styles.iconEarth} />
                <p>{currentLangMessageId}</p>
                <img src={this.state.flag ? arrowUp : arrowDown} className={styles.iconArrow} />
                {
                    this.state.flag &&
                    <div
                        className={styles.langSelectWrap}
                        style={{ backgroundColor: this.props.white ? 'rgba(11, 51, 76, 0.7)' : '#fff' }}
                    >
                        {
                            this.langList.map(item => (
                                <p
                                    className={styles.langItem}
                                    key={item.messageId}
                                    style={{
                                        backgroundColor: this.props.white ? (item.value === getLang() ? 'rgba(11, 51, 76, 0.9)' : '') : '#fff',
                                        color: this.props.white ? '#fff' : (item.value === getLang() ? '#eb6a1a' : '')
                                    }}
                                    onClick={(e) => this.switchLang(e, item.value)}
                                >
                                    {item.messageId}
                                </p>
                            ))
                        }
                    </div>
                }
            </div>
        )
    }
}

export default SwitchLang
